/*
 * File: ProcedureFormEditButton.js
 * Project: mp-mobile-app
 *
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the Save button while editing a procedure in Billing Order
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";

const styles = theme => ({
  buttonContainer: {
    background: theme.palette.common.white,
    position: "fixed",
    left: 0,
    bottom: 0,
    padding: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(2)}px)`
  },
  gradientBackground: {
    background: theme.palette.common.buttonGradient,
    color: theme.palette.common.white
  }
});

const ProcedureFormEditButtons = ({ classes, onSaveClick }) => {
  return (
    <div className={classes.buttonContainer}>
      <Button
        variant="contained"
        onClick={onSaveClick}
        fullWidth
        className={classes.gradientBackground}
      >
        {"Save Changes"}
      </Button>
    </div>
  );
};

ProcedureFormEditButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  onSaveClick: PropTypes.func.isRequired
};

export default withStyles(styles)(ProcedureFormEditButtons);
